import { CheckoutPageId } from 'checkout/constants/pages'
import { LUXURY_PLUS } from 'luxPlus/constants/base'

export const CRUISE_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: 'Passengers',
    key: CheckoutPageId.CruiseTravelers,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'Type & Category',
    key: 'cabin-type-category',
    subSteps: [
      {
        label: 'Cabin type',
        key: CheckoutPageId.CruiseCabinType,
        isRoute: true,
      },
      {
        label: 'Cabin category',
        key: CheckoutPageId.CruiseCabinCategory,
        isRoute: true,
      },
    ],
    isRoute: true,
  },
  {
    label: 'Location',
    key: CheckoutPageId.CruiseCabinLocation,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Package',
    key: CheckoutPageId.CruiseCabinPackage,
    isRoute: true,
    subSteps: [],
  },
  {
    label: LUXURY_PLUS.PROGRAM_NAME,
    key: CheckoutPageId.LuxPlus,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'Review & Payment',
    key: CheckoutPageId.Purchase,
    subSteps: [],
    isRoute: true,
  },
]
